// extracted by mini-css-extract-plugin
module.exports = {"official-representative":"_93444fe79c--official-representative--Fq1eI","link":"_93444fe79c--link--gCFNZ"};